import { Badge } from "@chakra-ui/react";

export function OptionalTag(props: React.ComponentProps<typeof Badge>) {
  return (
    <Badge size="sm" variant="outline" colorPalette="yellow" {...props}>
      任意
    </Badge>
  );
}
